import script from "./Whatsapp-logo.vue?vue&type=script&setup=true&lang=js"
export * from "./Whatsapp-logo.vue?vue&type=script&setup=true&lang=js"

import "./Whatsapp-logo.vue?vue&type=style&index=0&id=0ce15266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce15266"]])

export default __exports__